import { ArrivalScanResponse } from '../services/arrivalScan.endpoints';
import { Box, Typography, Fade, Zoom } from '@mui/material';
import SuccessView from './ResultOverlay/SuccessView';
import ErrorView from './ResultOverlay/ErrorView';
import { keyframes } from '@mui/system';
import React from 'react';

const shrinkWidth = keyframes`
  from { width: 0%; }
  to   { width: 100%; }
`;

interface ResultOverlayProps {
  show: boolean;
  result: ArrivalScanResponse | null;
  error: string | null;
  failedShippingNumber: number | null;
  onClose: () => void;
}

const ResultOverlay: React.FC<ResultOverlayProps> = ({
  show,
  result,
  error,
  failedShippingNumber,
  onClose,
}) => {
  return (
    <Fade in={show} timeout={250}>
      <Box
        sx={{
          position: 'fixed',
          top: 0,
          left: 0,
          right: 0,
          bottom: 0,
          backgroundColor: result ? '#059669' : '#EF4444',
          display: 'flex',
          flexDirection: 'column',
          alignItems: 'center',
          justifyContent: 'center',
          zIndex: 9999,
          color: 'white',
          padding: '2rem',
          textAlign: 'center',
          fontFamily: 'Karla, sans-serif',
        }}
        onClick={onClose}
      >
        <Zoom in={show} style={{ transitionDelay: show ? '50ms' : '0ms' }}>
          <Box sx={{ maxWidth: '100%', width: '100%' }}>
            {result ? (
              <SuccessView result={result} />
            ) : (
              <ErrorView
                error={error}
                shippingNumber={failedShippingNumber}
                onClose={onClose}
              />
            )}

            {result && (
              <Typography
                variant='body2'
                sx={{
                  mt: 12,
                  opacity: 0.4,
                  fontWeight: 700,
                  textTransform: 'uppercase',
                  letterSpacing: '3px',
                  fontSize: '0.75rem',
                }}
              >
                Haz clic en cualquier lugar para continuar
              </Typography>
            )}
          </Box>
        </Zoom>

        {result && (
          <Box
            key={result.shippingNumber}
            sx={{
              position: 'absolute',
              bottom: 0,
              left: 0,
              height: '12px',
              width: '100%',
              backgroundColor: 'rgba(255,255,255,0.85)',
              borderRadius: '0 2px 2px 0',
              animation: `${shrinkWidth} 1s linear forwards`,
            }}
          />
        )}
      </Box>
    </Fade>
  );
};

export default ResultOverlay;
